import { useEffect, useMemo, useState } from "react";
import { getCMSData, getGlobalData } from "../Service/ApiFunction";
import CommonContext from "./context";
export const CtxState = ({ children }) => {
  const [GlobalData, setGlobalData] = useState();
  const [cmsData, setCMSData] = useState();
  const [orderPaymentId, setOrderPaymentId] = useState({
    orderId: "",
    paymentId: "",
  });
  const fetchGlobalData = async () => {
    const response = await getGlobalData();

    setGlobalData(response?.data);
  };

  const fetchCMSData = async () => {
    const response = await getCMSData();
    setCMSData(response?.data);
  };
  useEffect(() => {
    fetchGlobalData();
    fetchCMSData();
  }, []);

  const ContactNumber =
    GlobalData?.length &&
    GlobalData?.find((ele) => ele?.title == "school_Contact_Number");

  const FromPrincipalDesktop = GlobalData?.find(
    (ele) => ele?.title == "from_the_desk_of_principle"
  );

  const LocationLink = GlobalData?.find((ele) => ele?.title == "map");

  const faceBookLink = GlobalData?.find(
    (ele) => ele?.title == "facebook"
  )?.file;
  const InstagramLink = GlobalData?.find(
    (ele) => ele?.title == "instagram"
  )?.file;
  const TwitterLink = GlobalData?.find((ele) => ele?.title == "twitter")?.file;
  const LinkedInLink = GlobalData?.find(
    (ele) => ele?.title == "linkedin"
  )?.file;

  let AllLink = useMemo(
    () => [faceBookLink, InstagramLink, TwitterLink, LinkedInLink],
    [GlobalData]
  );

  return (
    <CommonContext.Provider
      value={{
        GlobalData,
        cmsData,
        ContactNumber,
        FromPrincipalDesktop,
        LocationLink,
        AllLink,
        orderPaymentId,
        setOrderPaymentId,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};
